import React from "react";
import { Form } from "react-bootstrap";
import WorkersMultiSelect from "./WorkersMultiSelect";
import ProjectsMultiSelect from "./ProjectsMultiSelect";
import ApprovalStatusMultiSelect from "./ApprovalStatusMultiSelect";

const ManagerOptions = ({
  currentPage,
  isShowingWorkers,
  workers,
  selectedWorkersObjects,
  onSelectWorkers,
  projects,
  selectedProjectsObjects,
  onSelectProjects,
  approvalStatus,
  onSelectApprovalStatus,
  handleSetActive,
}) => {
  const showToggle = currentPage !== "Planner";

  return (
    <span className="managerOptions">
      <span>
        <WorkersMultiSelect
          currentPage={currentPage}
          isShowingWorkers={isShowingWorkers}
          workers={workers}
          selectedWorkersObjects={selectedWorkersObjects}
          onSelectWorkers={onSelectWorkers}
        />
      </span>
      {showToggle && (
        <Form.Check
          type="switch"
          id="workers-projects-toggle"
          label=""
          checked={!isShowingWorkers}
          onChange={handleSetActive}
          className="toggle"
        />
      )}

      {currentPage !== "Planner" && (
        <span>
          <span>
            <span>
              <ProjectsMultiSelect
                currentPage={currentPage}
                isShowingWorkers={isShowingWorkers}
                projects={projects}
                selectedProjectsObjects={selectedProjectsObjects}
                onSelectProjects={onSelectProjects}
              />
            </span>
          </span>
        </span>
      )}
      {currentPage === "Planner" && (
        <span>
          <span>
            <ApprovalStatusMultiSelect
              approvalStatus={approvalStatus}
              onSelectApprovalStatus={onSelectApprovalStatus}
            />
          </span>
        </span>
      )}
    </span>
  );
};

export default ManagerOptions;
